<template>
  <div class="sidebar_wrapper">
    <img v-if="showBack" class="sidebar_back_icon" :src="backIcon" alt="返回按钮" @click.stop="onBack" />
    <div class="sidebar_content_wrapper">
      <div class="sidebar_title">问真国学文化</div>
      <div class="sidebar_list">
        <div class="sidebar_list_item pointer" :class="{ 'sidebar_list_item_selected': navIndex === item.id }"
          v-for="item in navList" :key="item.id" @click.stop="onNav(item)">{{ item.name
          }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router'

const route = useRoute()
const backIcon = require('@/assets/images/icon-back.png')

/**
 * 导航栏
 */
const _navList = [
  {
    id: 0,
    name: '首页',
  },
  {
    id: 1,
    name: '道教常识',
  },
  {
    id: 2,
    name: '道教历史',
  },
  {
    id: 3,
    name: '道家经典',
  },
  {
    id: 4,
    name: '道教名山',
  },
  {
    id: 5,
    name: '宗教法规',
  },
]
const navList = reactive(_navList)
const navIndex = ref(0)

/**
 * 显示返回按钮
 */
const showBack = ref(route.name === 'ArticleDetail')

/**
 * 监听路由
 */
watch(
  () => route.name,
  (res) => {
    showBack.value = res === 'ArticleDetail'
    if (res === 'ArticleList' && navIndex.value === 0) {
      const id = route.query.id
      if (id !== undefined) {
        navIndex.value = +id + 1
      }
    }
  }
)

const init = () => {
  if (route.name === 'ArticleList' || route.name === 'ArticleDetail') {
    const id = route.query.id
    if (id !== undefined) navIndex.value = +id + 1
  }
}

/**
 * 路由跳转函数
 * @param {String} path 跳转路径
 */
const onNav = (item) => {
  navIndex.value = item.id
  let isHome = item.id === 0
  const pathObj = {
    path: isHome ? '/home/index' : '/home/articleList',
  }
  if (!isHome) {
    pathObj.query = {
      id: item.id - 1
    }
  }
  router.replace(pathObj)
}

/**
 * 返回函数
 */
const onBack = () => {
  showBack.value = false
  router.back()
}

init()
</script>

<style scoped lang="less">
.sidebar_wrapper {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  min-width: calc(@maxWidth + 70px);
  height: @sidebarHeight;
  margin: 0 auto;
  background-color: @sidebarBg;

  .sidebar_back_icon {
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
    width: 25px;
    height: 25px;
    padding: 5px 15px;
  }

  .sidebar_content_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: @maxWidth;
    height: 100%;
    margin: auto;
  }

  .sidebar_title {
    font-family: "Microsoft JhengHei ", "Microsoft YaHei", "Source Han Sans", SimHei;
    font-size: 17px;
    white-space: nowrap;
  }


  ::-webkit-scrollbar {
    display: none;
  }

  .sidebar_list {
    display: flex;
    padding: 10px 0;
    margin-left: 20px;
    color: @defaultColor;
    overflow-x: auto;
    overflow-y: hidden;

    .sidebar_list_item {
      position: relative;
      margin-left: 15px;
      font-size: 14px;
      white-space: nowrap;

      &:hover {
        color: @mainColor;
      }
    }

    .sidebar_list_item_selected {
      color: @mainColor;

      &::after {
        content: "";
        position: absolute;
        bottom: -3px;
        left: 0;
        right: 0;
        width: 88%;
        height: 2px;
        margin: 0 auto;
        background-color: @mainColor;
      }
    }
  }
}
</style>
